import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import NavbarStandard from 'components/pages/landing/NavbarStandard';
import FooterStandard from 'components/pages/landing/FooterStandard';

const sections = [
  {
    title: 'CLÁUSULA PRIMERA: EL REGISTRO',
    body: [
      '1.1. Para utilizar los servicios de GESTODO, el Usuario deberá registrarse creando una cuenta (la “Cuenta”), proporcionando información veraz, completa y actualizada.',
      '1.2. El Usuario podrá vincular su Cuenta con plataformas de terceros, incluyendo Mercado Libre, autorizando a GESTODO a acceder a la información necesaria para la prestación del servicio.',
      '1.3. El Usuario será el único responsable de la Cuenta y se obliga a no revelar su contraseña a terceros. Toda actividad realizada desde la Cuenta será considerada realizada por el Usuario.',
      '1.4. La Cuenta es personal, única e intransferible. GESTODO podrá rechazar, suspender o cancelar cualquier Cuenta a su exclusivo criterio.',
      '1.5. GESTODO podrá solicitar información adicional para verificar los datos proporcionados y suspender cuentas cuyos datos no hayan podido ser verificados.'
    ]
  },
  {
    title: 'CLÁUSULA SEGUNDA: CONDICIONES GENERALES DEL SERVICIO',
    body: [
      '2.1. GESTODO ofrece una plataforma tecnológica bajo modalidad SaaS destinada a optimizar la gestión comercial, operativa y analítica de los Usuarios.',
      '2.2. Los servicios podrán incluir, sin limitarse a: automatización de respuestas, gestión de clientes (CRM), análisis de datos, integraciones con plataformas externas, herramientas de postventa y agentes automatizados.',
      '2.3. GESTODO no interviene en las operaciones comerciales de los Usuarios ni garantiza resultados económicos, de ventas o posicionamiento.',
      '2.4. GESTODO se reserva el derecho de modificar, agregar o eliminar funcionalidades del servicio en cualquier momento.'
    ]
  },
  {
    title: 'CLÁUSULA TERCERA: INTEGRACIÓN CON PLATAFORMAS DE TERCEROS',
    body: [
      '3.1. El servicio de GESTODO puede operar mediante integraciones con plataformas de terceros, incluyendo Mercado Libre y otras APIs.',
      '3.2. El Usuario reconoce que dichas plataformas son independientes y que GESTODO no tiene control sobre su funcionamiento.',
      '3.3. GESTODO no será responsable por interrupciones o errores en plataformas externas, cambios en APIs, bloqueos de cuentas y pérdida de datos provenientes de terceros.',
      '3.4. El Usuario acepta los riesgos inherentes al uso de integraciones externas.'
    ]
  },
  {
    title: 'CLÁUSULA CUARTA: PLANES Y CONDICIONES DE PAGO',
    body: [
      '4.1. El acceso a los servicios podrá requerir la contratación de un plan (el “Plan”).',
      '4.2. Los pagos deberán realizarse por adelantado mediante los medios habilitados.',
      '4.3. Los pagos no serán reembolsables, salvo disposición expresa en contrario.',
      '4.4. Los planes se renovarán automáticamente salvo cancelación previa del Usuario.',
      '4.5. En caso de falta de pago, GESTODO podrá suspender o cancelar la Cuenta sin previo aviso.',
      '4.6. En planes anuales, la cancelación anticipada podrá generar cargos adicionales conforme a las condiciones comerciales vigentes.'
    ]
  },
  {
    title: 'CLÁUSULA QUINTA: BAJA DEL SERVICIO',
    body: [
      '5.1. El Usuario podrá solicitar la baja desde su Cuenta o mediante comunicación a info@gestodo.net.',
      '5.2. La baja evitará renovaciones futuras, pero no generará devolución de importes abonados.'
    ]
  },
  {
    title: 'CLÁUSULA SEXTA: USO DEL SITIO',
    body: [
      '6.1. El Usuario se compromete a utilizar el Sitio de manera lícita y conforme a estos Términos.',
      '6.2. El Usuario se obliga a no utilizar el servicio para fines ilícitos, vulnerar sistemas de seguridad, acceder a datos de terceros, introducir virus o software malicioso, ni revender el servicio sin autorización.',
      '6.3. Queda prohibido el uso de scraping, bots o herramientas automatizadas para extraer información del Sitio sin autorización previa.'
    ]
  },
  {
    title: 'CLÁUSULA SÉPTIMA: RESPONSABILIDAD',
    body: [
      '7.1. GESTODO únicamente pone a disposición herramientas tecnológicas.',
      '7.2. El Usuario reconoce que utiliza el servicio bajo su propio riesgo.',
      '7.3. GESTODO no será responsable por pérdidas económicas, decisiones comerciales del Usuario, fallas del sistema y problemas con terceros.',
      '7.4. La información brindada por GESTODO es estimativa y no garantiza exactitud.'
    ]
  },
  {
    title: 'CLÁUSULA OCTAVA: DISPONIBILIDAD DEL SERVICIO',
    body: [
      '8.1. GESTODO no garantiza la disponibilidad continua del servicio.',
      '8.2. No será responsable por interrupciones, fallas técnicas o accesos no autorizados.'
    ]
  },
  {
    title: 'CLÁUSULA NOVENA: PROPIEDAD INTELECTUAL',
    body: [
      '9.1. Todos los derechos sobre la plataforma pertenecen a BYTEWAVE S.A.',
      '9.2. Queda prohibido reproducir, modificar o comercializar el contenido sin autorización.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMA: PROTECCIÓN DE DATOS',
    body: [
      '10.1. Los datos personales serán tratados conforme a la legislación vigente.',
      '10.2. El Usuario podrá ejercer sus derechos de acceso, rectificación y eliminación.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOPRIMERA: NOTIFICACIONES',
    body: [
      '11.1. Las comunicaciones se realizarán a través del sitio o al correo electrónico del Usuario.',
      '11.2. El Usuario podrá comunicarse con GESTODO a info@gestodo.net.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOSEGUNDA: CESIÓN',
    body: [
      '12.1. El Usuario no podrá ceder su Cuenta sin autorización.',
      '12.2. GESTODO podrá ceder estos Términos sin consentimiento previo.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOTERCERA: LEY APLICABLE Y JURISDICCIÓN',
    body: [
      '13.1. Estos Términos se regirán por las leyes de la República Argentina.',
      '13.2. Cualquier controversia será sometida a los tribunales ordinarios con competencia en la Ciudad Autónoma de Buenos Aires.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOCUARTA: AGENTES DE INTELIGENCIA ARTIFICIAL Y AUTOMATIZACIONES',
    body: [
      '14.1. GESTODO podrá ofrecer funcionalidades basadas en inteligencia artificial, automatización y agentes autónomos, incluyendo agentes de respuesta automática, agentes de postventa, asistentes conversacionales, automatización de flujos de mensajes, generación de contenido automático, clasificación de leads o clientes y ejecución de acciones sobre cuentas vinculadas.',
      '14.2. El Usuario reconoce que los Agentes funcionan mediante algoritmos, modelos de aprendizaje automático y reglas preconfiguradas, pudiendo operar de manera autónoma o semi-autónoma.',
      '14.3. El Usuario es el único responsable por la configuración de los Agentes, el contenido generado o enviado, las decisiones automatizadas y las acciones ejecutadas en plataformas de terceros.',
      '14.4. GESTODO no garantiza exactitud de las respuestas generadas, adecuación del contenido, cumplimiento de expectativas comerciales ni ausencia de errores en automatizaciones.',
      '14.5. El Usuario acepta que los Agentes pueden generar respuestas incorrectas o incompletas, interpretar de manera errónea consultas de usuarios finales y ejecutar acciones no deseadas si están mal configurados.',
      '14.6. GESTODO no será responsable por daños derivados del uso de los Agentes, incluyendo pérdida de ventas, conflictos con clientes, sanciones de plataformas externas y errores en comunicación automática.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOQUINTA: USO DE IA Y GENERACIÓN DE CONTENIDO',
    body: [
      '15.1. El Usuario reconoce que el contenido generado por inteligencia artificial puede no ser exacto, completo o actualizado.',
      '15.2. GESTODO no garantiza la originalidad ni la ausencia de similitud con contenidos de terceros.',
      '15.3. El Usuario se compromete a revisar, validar y supervisar cualquier contenido generado antes de su uso comercial o público.',
      '15.4. El Usuario será responsable por cualquier uso del contenido generado, incluyendo publicaciones, mensajes a clientes, respuestas automatizadas y campañas comerciales.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOSEXTA: AUTOMATIZACIONES Y EJECUCIÓN DE ACCIONES',
    body: [
      '16.1. GESTODO podrá permitir la automatización de acciones en plataformas externas mediante integraciones.',
      '16.2. Estas acciones pueden incluir envío de mensajes, modificación de datos, activación de flujos, respuestas automáticas y gestión de publicaciones.',
      '16.3. El Usuario autoriza expresamente a GESTODO a ejecutar dichas acciones en su nombre cuando active dichas funcionalidades.',
      '16.4. El Usuario asume la totalidad del riesgo derivado de dichas automatizaciones.',
      '16.5. GESTODO no será responsable por errores en ejecuciones automáticas, bloqueos de cuentas por uso automatizado, limitaciones impuestas por plataformas externas y acciones ejecutadas conforme a configuraciones del Usuario.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOSÉPTIMA: LIMITACIONES DE USO DE AGENTES',
    body: [
      '17.1. El Usuario se compromete a no utilizar los Agentes para realizar spam, acosar o engañar usuarios, suplantar identidad sin aclaración, incumplir políticas de plataformas externas o difundir contenido ilegal o engañoso.',
      '17.2. GESTODO podrá limitar, suspender o desactivar Agentes que considere riesgosos o contrarios a estos Términos.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMOCTAVA: SUPERVISIÓN Y CONTROL',
    body: [
      '18.1. El Usuario reconoce que los Agentes requieren supervisión humana.',
      '18.2. GESTODO no es responsable por la falta de control, monitoreo o validación por parte del Usuario.'
    ]
  },
  {
    title: 'CLÁUSULA DÉCIMONOVENA: EVOLUCIÓN TECNOLÓGICA',
    body: [
      '19.1. El Usuario reconoce que las funcionalidades de inteligencia artificial pueden cambiar, evolucionar o ser reemplazadas sin previo aviso.',
      '19.2. GESTODO podrá modificar el funcionamiento de los Agentes para mejorar el servicio.'
    ]
  }
];

const TermsPage = () => {
  return (
    <>
      <NavbarStandard solid />
      <main>
        <section className="bg-300 py-6 mt-6">
          <Container>
            <h1 className="mb-3">Términos y Condiciones de Uso de Gestodo</h1>
            <p className="text-700 mb-2">
              BYTEWAVE S.A.
            </p>
            <p className="text-700 mb-0">
              Los presentes términos y condiciones regulan la relación contractual entre los Usuarios y BYTEWAVE S.A., CUIT 30-71828181-0 correo electrónico de contacto info@gestodo.net y sitio web http://gestodo.net.
            </p>
          </Container>
        </section>
        <section className="py-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={9}>
                <Card className="border shadow-sm">
                  <Card.Body className="p-4 p-lg-5">
                    <p className="fw-semi-bold text-uppercase text-danger mb-4">
                      Cualquier persona que no acepte estos términos y condiciones, los cuales tienen carácter obligatorio y vinculante, deberá abstenerse de utilizar el sitio y/o los servicios.
                    </p>
                    <p>
                      El Usuario declara haber leído, entendido y aceptado todas las condiciones establecidas en los presentes Términos y Condiciones.
                    </p>
                    <p>
                      GESTODO se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento, notificando a los Usuarios mediante su publicación en el sitio o a través de los medios de contacto declarados. La continuación en el uso del servicio implicará la aceptación de las modificaciones.
                    </p>
                    {sections.map(section => (
                      <div key={section.title} className="mb-4">
                        <h4 className="mt-4 mb-3">{section.title}</h4>
                        {section.body.map(paragraph => (
                          <p key={paragraph} className="mb-3 text-700">
                            {paragraph}
                          </p>
                        ))}
                      </div>
                    ))}
                    <hr className="my-4" />
                    <h5 className="mb-3">DATOS DE LA EMPRESA</h5>
                    <p className="mb-1">BYTEWAVE S.A.</p>
                    <p className="mb-1">CUIT: 30-71828181-0</p>
                    <p className="mb-1">Sitio web: http://gestodo.net</p>
                    <p className="mb-0">Email: info@gestodo.net</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <FooterStandard />
    </>
  );
};

export default TermsPage;
